class UserAdminService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    /***
     * Get a list of all of the users.
     */
    getUsers(params) {
        const config = params ? {params: params} : {};
        return this.$http.get(`${this.appConfig.apiUrl}/users/`, config)
            .then((successResponse) => successResponse.data);
    }
}

export default UserAdminService;


// WEBPACK FOOTER //
// ./app/components/user-admin/user-admin-service.js